var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fuild"},[_c('div',{staticClass:"bg-dark"},[_c('h1',{staticClass:"section-title underlined"},[_vm._v("\n        "+_vm._s(_vm.$t('Aucun bien immobilier'))),_c('span',[_vm._v(" "+_vm._s(_vm.$t('n\'a été trouvé')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }